/* Site — card swatches, quick-add popup, mobile hero video, collection SEO toggle. */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var strings = window.siteStrings || {};
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Card swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.site-swatch');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.card-wrapper');
    if (!card) return;

    card.querySelectorAll('.site-swatch.is-active').forEach(function (b) { b.classList.remove('is-active'); });
    sw.classList.add('is-active');

    var name = card.querySelector('[data-site-color-name]');
    if (name) name.textContent = sw.dataset.color;

    var img = card.querySelector('.card__media img');
    if (img && sw.dataset.src) {
      img.srcset = sw.dataset.srcset || '';
      img.src = sw.dataset.src;
    }
    if (sw.dataset.url) {
      card.querySelectorAll('a.full-unstyled-link').forEach(function (a) { a.href = sw.dataset.url; });
    }
    var qa = card.querySelector('[data-site-quick-add]');
    if (qa && sw.dataset.variantId) qa.dataset.variantId = sw.dataset.variantId;
  });

  /* ---------- Quick-add popup ---------- */
  var dialog = null;
  var state = null;

  function getDialog() {
    if (!dialog) {
      dialog = document.getElementById('SiteQuickAdd');
      if (!dialog) return null;
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-site-qa-close]')) dialog.close();
      });
    }
    return dialog;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=site-quick')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        cache[handle] = data;
        return data;
      });
  }

  // "41mm (Series 7-9)" and "Apple Watch Series 11 & 10 - 42mm" both -> "41mm" / "42mm"
  function mmOf(value) {
    var m = /(\d{2})\s*mm/i.exec(value || '');
    return m ? m[1] + 'mm' : null;
  }

  // Size label the shopper already picked on the product page (e.g. "Apple Watch Series 10-12 - 42mm"),
  // used to pre-select the size of an upsell / bundle product.
  function sizeFromPage() {
    var picker = document.querySelector('product-info variant-selects, variant-selects');
    if (!picker) return null;
    var values = [];
    picker.querySelectorAll('select').forEach(function (s) { values.push(s.value); });
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (i) { values.push(i.value); });
    for (var i = 0; i < values.length; i++) {
      if (mmOf(values[i])) return values[i];
    }
    return null;
  }

  // Watch sizes mentioned in a label: "Series 1-9 & SE - 38/40/41mm" -> [38, 40, 41], "Series 7-9 (41MM)" -> [41]
  function sizesIn(label) {
    var out = [], re = /(\d{2})(?=\s*(?:\/|mm))/gi, m;
    while ((m = re.exec(label || ''))) out.push(m[1]);
    return out;
  }
  // Watch generation, to tell "Series 1-3 (42MM)" from "Series 10 & 11 (42MM)"
  function generationOf(label) {
    if (/ultra/i.test(label)) return 'ultra';
    if (/\b1[0-2]\b/.test(label)) return 'new';
    return 'old';
  }
  // Best value among `values` for the hint label (straps <-> cases use different wording)
  function pickByHint(values, hint) {
    var hs = sizesIn(hint);
    if (!hs.length) return null;
    var gen = generationOf(hint), last = hs[hs.length - 1], best = null, bestScore = 0;
    values.forEach(function (v) {
      var vs = sizesIn(v);
      var shared = vs.filter(function (n) { return hs.indexOf(n) > -1; }).length;
      if (!shared) return;
      var score = shared * 10 + (generationOf(v) === gen ? 5 : 0) + (vs.indexOf(last) > -1 ? 1 : 0);
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best;
  }

  window.sitePickByHint = pickByHint;
  window.siteSizeFromPage = sizeFromPage;

  function findVariant(selected) {
    return state.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
  }

  function valueAvailable(optIndex, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, i) { return i === optIndex || o === state.selected[i]; });
    });
  }

  function render() {
    var p = state.product;
    var v = findVariant(state.selected);
    var html = '';
    html += '<div class="site-qa__media"><img src="' + esc((v && v.image) || p.image) + '" alt="' + esc(p.title) + '" width="900" height="900"></div>';
    html += '<div class="site-qa__info">';
    html += '<h2 class="site-qa__title" id="SiteQuickAddTitle">' + esc(p.title) + '</h2>';
    html += '<p class="site-qa__price">' + (v ? esc(v.price) + (v.compare ? ' <s>' + esc(v.compare) + '</s>' : '') : '') + '</p>';

    p.options.forEach(function (opt, oi) {
      if (opt.values.length < 2 && !opt.color) {
        return;
      }
      if (!opt.color) {
        // sizes & other options: dropdown
        var sid = 'SiteQaOpt-' + oi;
        var guide = strings.sizeGuide && /size/i.test(opt.name)
          ? '<button type="button" class="site-size-guide-link" data-site-dialog-open="SiteSizeGuideGlobal">' +
            '<svg class="icon" aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.3"/><path d="M10 9v5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="10" cy="6.3" r=".9" fill="currentColor"/></svg>' +
            esc(strings.sizeGuide) + '</button>'
          : '';
        html += '<div class="site-qa__option site-qa__option--select"><div class="site-option-head"><label class="site-qa__label" for="' + sid + '">' + esc(opt.name) + '</label>' + guide + '</div>';
        html += '<div class="site-qa__select-wrap"><select id="' + sid + '" class="site-qa__select" data-opt="' + oi + '">';
        opt.values.forEach(function (val) {
          var avail = valueAvailable(oi, val.name);
          html += '<option value="' + esc(val.name) + '"' + (state.selected[oi] === val.name ? ' selected' : '') + '>' +
            esc(val.name) + (avail ? '' : ' — ' + esc(strings.unavailable)) + '</option>';
        });
        html += '</select><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div></div>';
        return;
      }
      html += '<fieldset class="site-qa__option site-qa__option--color">';
      html += '<legend>' + esc(opt.name) + ': <strong>' + esc(state.selected[oi]) + '</strong></legend><div class="site-qa__values">';
      opt.values.forEach(function (val) {
        var on = state.selected[oi] === val.name;
        var avail = valueAvailable(oi, val.name);
        var cls = 'site-qa__value site-swatch-btn' + (on ? ' is-active' : '') + (avail ? '' : ' is-unavailable');
        // product photo of that color when available, color swatch otherwise
        var inner = val.img
          ? '<img class="site-qa__thumb" src="' + esc(val.img) + '" alt="" width="64" height="64">'
          : '<span class="site-swatch site-swatch--static" data-swatch="' + esc(val.handle) + '"></span>';
        html += '<button type="button" class="' + cls + (val.img ? ' has-img' : '') + '" data-opt="' + oi + '" data-val="' + esc(val.name) + '" aria-pressed="' + on + '" title="' + esc(val.name) + '">' +
          inner + '<span class="visually-hidden">' + esc(val.name) + '</span></button>';
      });
      html += '</div></fieldset>';
    });

    var label = !v ? strings.unavailable : v.available ? strings.addToCart + ' – ' + v.price : strings.soldOut;
    html += '<button type="button" class="site-qa__add button" data-site-qa-add' + (v && v.available ? '' : ' disabled') + '>' + esc(label) + '</button>';
    html += '<p class="site-qa__error" role="alert" hidden></p>';
    html += '<a class="site-qa__details" href="' + esc(p.url) + (v ? '?variant=' + v.id : '') + '">' + esc(strings.viewDetails || 'View full details') + ' →</a>';
    html += '</div>';
    state.body.innerHTML = html;
  }

  function openQuickAdd(btn) {
    if (btn.hasAttribute('data-current-product')) {
      var pageVariant = document.querySelector('product-info [name="id"], .product-form [name="id"]');
      if (pageVariant && pageVariant.value) btn.dataset.variantId = pageVariant.value;
    }
    var dlg = getDialog();
    if (!dlg) return;
    var body = dlg.querySelector('[data-site-qa-body]');
    btn.classList.add('is-loading');

    fetchProduct(btn.dataset.handle)
      .then(function (product) {
        var start = product.variants.find(function (v) { return String(v.id) === btn.dataset.variantId; }) ||
          product.variants.find(function (v) { return v.available; }) || product.variants[0];
        state = { product: product, selected: start.options.slice(), body: body, opener: btn, bundle: btn.hasAttribute('data-bundle') };

        var hint = btn.dataset.sizeHint ||
          (btn.hasAttribute('data-size-from-page') || btn.hasAttribute('data-bundle') ? sizeFromPage() : null) ||
          (btn.hasAttribute('data-bundle') ? window.siteCartSizeHint : null);
        if (hint) {
          product.options.forEach(function (opt, oi) {
            var match = pickByHint(opt.values.map(function (val) { return val.name; }), hint);
            if (match) state.selected[oi] = match;
          });
          var v = findVariant(state.selected);
          if (!v || !v.available) {
            // keep the size, fall back to any available variant of that size
            var sizeIdx = state.selected.findIndex(function (x) { return /\d\s*mm/i.test(x); });
            var alt = product.variants.find(function (x) { return x.available && (sizeIdx < 0 || x.options[sizeIdx] === state.selected[sizeIdx]); });
            if (alt) state.selected = alt.options.slice();
          }
        }
        render();
        if (!dlg.open) dlg.showModal();
      })
      .catch(function (err) {
        // fallback: open the product page; keep the reason for debugging
        try { sessionStorage.setItem('siteQaError', String((err && err.stack) || err)); } catch (e) {}
        if (window.console) console.error('Quick add failed', err);
        window.location.href = root + 'products/' + btn.dataset.handle;
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  function addToCart(btn) {
    var v = findVariant(state.selected);
    if (!v || !v.available) return;
    if (typeof window.sitePick === 'function') {
      // Bundle & Save slot picking: hand the variant back instead of adding it to the cart
      var pick = window.sitePick;
      window.sitePick = null;
      dialog.close();
      pick({ variant: v, product: state.product });
      return;
    }
    var errorEl = state.body.querySelector('.site-qa__error');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer) {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : root + 'cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          errorEl.textContent = res.json.description || res.json.message || strings.error;
          errorEl.hidden = false;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'site-quick-add', productVariantId: v.id, cartData: res.json });
        }
        dialog.close();
        if (state.bundle && window.siteBundle) {
          // stay in the bundle popup: refresh the drawer silently, update progress
          window.siteBundle.afterAdd(res.json, state.opener);
          return;
        }
        if (drawer && res.json.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
      })
      .catch(function () {
        errorEl.textContent = strings.error;
        errorEl.hidden = false;
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  }

  function selectValue(oi, value) {
    state.selected[oi] = value;
    var v = findVariant(state.selected);
    if (!v || !v.available) {
      // keep the chosen value, fall back to an available combination
      var alt = state.product.variants.find(function (x) { return x.available && x.options[oi] === value; });
      if (alt) state.selected = alt.options.slice();
    }
    render();
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.site-qa__select');
    if (sel && state) selectValue(Number(sel.dataset.opt), sel.value);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-site-quick-add]');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      openQuickAdd(opener);
      return;
    }
    if (!state || !dialog || !dialog.contains(e.target)) return;

    var valBtn = e.target.closest('.site-qa__value');
    if (valBtn) {
      selectValue(Number(valBtn.dataset.opt), valBtn.dataset.val);
      return;
    }
    var addBtn = e.target.closest('[data-site-qa-add]');
    if (addBtn) addToCart(addBtn);
  });

  /* ---------- Mobile "View more" on featured collections ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-site-view-more]');
    if (!btn) return;
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) return;
    var step = parseInt(btn.dataset.siteViewMore, 10) || 8;
    var hidden = list.querySelectorAll('.site-m-more');
    for (var i = 0; i < Math.min(step, hidden.length); i++) hidden[i].classList.remove('site-m-more');
    if (hidden.length <= step) {
      // everything is visible: the button becomes the "View all" link to the collection
      var link = document.createElement('a');
      link.className = btn.className;
      link.href = btn.dataset.viewAllUrl || '#';
      link.textContent = btn.dataset.viewAllLabel || 'View all';
      btn.replaceWith(link);
    }
  });

  /* ---------- Hero videos: only download the one matching the screen ---------- */
  function loadVideos() {
    document.querySelectorAll('video[data-site-video]:not([data-loaded])').forEach(function (video) {
      if (!window.matchMedia(video.dataset.siteVideo).matches) return;
      video.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
      video.setAttribute('data-loaded', '');
      video.load();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---------- Collection SEO "Read more" ---------- */
  function initSeo() {
    document.querySelectorAll('[data-site-seo].is-collapsible:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '');
      var body = box.querySelector('.site-seo__body');
      var toggle = box.querySelector('.site-seo__toggle');
      var limit = parseInt(getComputedStyle(box).getPropertyValue('--seo-collapsed'), 10) || 220;
      if (body.scrollHeight <= limit + 40) {
        box.classList.remove('is-collapsible');
        toggle.remove();
        return;
      }
      toggle.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
        toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
      });
    });
  }

  function init() {
    loadVideos();
    initSeo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.matchMedia('(max-width: 749px)').addEventListener('change', loadVideos);
  document.addEventListener('shopify:section:load', init);
})();

/* Site — sticky add-to-cart bar on product pages. */
if (!customElements.get('site-sticky-atc')) {
  customElements.define(
    'site-sticky-atc',
    class SiteStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this.btn = this.querySelector('button');
        this.mainBtn = document.querySelector('#' + this.dataset.form + ' [name="add"]');
        if (!this.mainBtn) return;
        // escape the sticky info column so position: fixed is relative to the viewport;
        // moving the element calls connectedCallback again, which then runs the setup below once
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        this._ready = true;
        // bundle option selected -> scroll to the Bundle & Save widget; otherwise (single strap, cases) add to cart directly
        this.btn.addEventListener('click', () => {
          const offer = document.querySelector('site-bundle-offer');
          if (!offer || offer.mode !== 'bundle') {
            this.mainBtn.click();
            return;
          }
          const target = offer;
          const header = document.querySelector('.section-header');
          const offset = (header ? header.getBoundingClientRect().height : 0) + 16;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
          // fallback if smooth scrolling didn't run (reduced motion, background tab…)
          setTimeout(() => { if (Math.abs(window.scrollY - top) > 40) window.scrollTo(0, top); }, 700);
          target.classList.remove('site-flash');
          void target.offsetWidth;
          target.classList.add('site-flash');
        });

        // visible once the main button has scrolled above the viewport
        const update = () => this.classList.toggle('is-visible', this.mainBtn.getBoundingClientRect().bottom < 0);
        window.addEventListener('scroll', update, { passive: true });
        update();

        this.sync();
        new MutationObserver(() => this.sync()).observe(this.mainBtn, { attributes: true, childList: true, subtree: true });
        const price = document.getElementById(this.dataset.price);
        if (price) new MutationObserver(() => this.sync()).observe(price, { childList: true, subtree: true, characterData: true });
      }

      sync() {
        const price = document.getElementById(this.dataset.price);
        const current = price && (price.querySelector('.price-item--sale') || price.querySelector('.price-item--regular'));
        const amount = current ? current.textContent.trim() : '';
        const disabled = this.mainBtn.disabled || this.mainBtn.getAttribute('aria-disabled') === 'true';
        this.btn.disabled = disabled;
        this.btn.textContent = disabled ? this.mainBtn.textContent.trim() : this.dataset.label + (amount ? ' – ' + amount : '');
      }
    }
  );
}

/* Site — dots under the mobile product gallery. */
(function () {
  function initDots() {
    document.querySelectorAll('media-gallery slider-component[id^="GalleryViewer"]:not([data-site-dots])').forEach(function (viewer) {
      var list = viewer.querySelector('.product__media-list');
      var slides = list ? Array.prototype.filter.call(list.children, function (li) { return li.offsetParent !== null || li.classList.contains('product__media-item'); }) : [];
      if (slides.length < 2) return;
      viewer.setAttribute('data-site-dots', '');
      var dots = document.createElement('div');
      dots.className = 'site-gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dots.appendChild(d);
      });
      viewer.after(dots);
      list.addEventListener('scroll', function () {
        var i = Math.round(list.scrollLeft / list.clientWidth);
        Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDots);
  else initDots();
})();

/* Site — generic dialogs (size guide). */
document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-site-dialog-open]');
  if (opener) {
    var dlg = document.getElementById(opener.dataset.siteDialogOpen);
    if (dlg && dlg.showModal) {
      if (dlg.parentElement !== document.body) document.body.appendChild(dlg); // escape transformed/sticky parents
      dlg.showModal();
    }
    return;
  }
  var dialog = e.target.closest('dialog.site-dialog');
  if (dialog && (e.target === dialog || e.target.closest('[data-site-dialog-close]'))) dialog.close();
});

/* Site — Buy X get Y: live progress bars + bundle builder popup. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Tiered offer: 2 cases = 10% off, 3+ cases = 15% off (same messages as snippets/site-bxgy-bar.liquid)
  function renderBars(count) {
    if (!window.siteBxgy) return;
    var msg;
    if (count === 0) msg = 'Buy 2 cases, save 10% · Buy 3, save 15%';
    else if (count === 1) msg = 'Add 1 more case to save 10%';
    else if (count === 2) msg = '🎉 10% off unlocked! Add 1 more case to save 15%';
    else msg = '🎉 15% off unlocked — applied at checkout!';
    var filled = Math.min(count, 3);
    var pct = Math.floor((filled * 100) / 3);

    document.querySelectorAll('.site-bxgy').forEach(function (bar) {
      bar.classList.toggle('is-unlocked', count >= 3);
      var m = bar.querySelector('.site-bxgy__msg');
      if (m) m.textContent = msg;
      var f = bar.querySelector('.site-bxgy__fill');
      if (f) f.style.width = pct + '%';
      bar.querySelectorAll('.site-bxgy__step').forEach(function (st, k) { st.classList.toggle('is-done', k + 1 <= filled); });
    });
  }

  function cartSizeHint(cart) {
    for (var i = cart.items.length - 1; i >= 0; i--) {
      var opts = cart.items[i].options_with_values || [];
      for (var j = 0; j < opts.length; j++) {
        if (/\d{2}\s*mm/i.test(opts[j].value) && /size/i.test(opts[j].name)) return opts[j].value;
      }
    }
    return null;
  }

  // Only eligible items count (e.g. straps, not cases): the count comes from the server (sections/site-bxgy-count.liquid)
  function refreshFromCart() {
    var sizeReq = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { window.siteCartSizeHint = cartSizeHint(cart); return cart; });
    var countReq = fetch(root + '?sections=site-bxgy-count')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = new DOMParser().parseFromString(s['site-bxgy-count'], 'text/html').getElementById('site-bxgy-state');
        if (el) renderBars(parseInt(el.dataset.count, 10) || 0);
      });
    return Promise.all([sizeReq, countReq]).then(function (r) { return r[0]; });
  }
  window.siteRefreshBxgy = refreshFromCart;

  function innerOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshFromCart(); });
  }
  // back/forward cache can restore a page with an outdated bar
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshFromCart();
  });

  var dlg = document.getElementById('SiteBundle');
  var addedSomething = false;

  window.siteBundle = {
    afterAdd: function (res, opener) {
      addedSomething = true;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && res.sections) {
        var inner = innerOf(res.sections['cart-drawer'], '#CartDrawer');
        var target = document.getElementById('CartDrawer');
        if (inner && target) target.innerHTML = inner;
        drawer.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleInner = res.sections['cart-icon-bubble'] && innerOf(res.sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleInner) bubble.innerHTML = bubbleInner;
      }
      var card = opener && opener.closest('.site-bundle-card');
      if (card && opener.hasAttribute('data-current-product') && current.template && current.template.dataset.againLabel) {
        opener.textContent = current.template.dataset.againLabel;
      }
      if (card) {
        var badge = card.querySelector('.site-bundle-card__added');
        var n = card.querySelector('[data-count]');
        n.textContent = badge.hidden ? 1 : Number(n.textContent) + 1;
        badge.hidden = false;
        card.classList.add('is-added');
      }
      refreshFromCart().then(function () {
        var bar = dlg && dlg.querySelector('.site-bundle__progress .site-bxgy');
        if (dlg && dlg.open && !dlg.classList.contains('is-picking') && bar && bar.classList.contains('is-unlocked')) {
          window.siteBundle.showUpsell('cart');
        }
      });
    }
  };

  if (!dlg) return;
  var body = dlg.querySelector('[data-site-bundle-body]');
  var loaded = false;

  // ---- optional "Complete your look" step once the offer is complete (Theme settings > Site — Buy X Get Y)
  var upsell = dlg.querySelector('[data-site-upsell]');
  var doneBtn = dlg.querySelector('[data-site-bundle-done]');
  var upsellLoaded = false;
  var upsellState = null;

  function showUpsell(mode, offer) {
    if (!upsell || dlg.dataset.upsellStep !== 'true') return false;
    upsellState = { mode: mode, offer: offer || null };
    body.hidden = true;
    upsell.hidden = false;
    upsell.scrollTop = 0;
    dlg.classList.add('is-upsell');
    if (doneBtn) doneBtn.textContent = doneBtn.dataset.labelGo || doneBtn.textContent;
    if (!upsellLoaded) {
      upsellLoaded = true;
      var url = upsell.dataset.url;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=site-upsell-products')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html').querySelector('.site-bundle-page');
          upsell.querySelector('[data-site-upsell-grid]').innerHTML = page ? page.innerHTML : '';
        })
        .catch(function () { upsellLoaded = false; });
    }
    return true;
  }
  function resetUpsell() {
    upsellState = null;
    if (upsell) upsell.hidden = true;
    body.hidden = false;
    dlg.classList.remove('is-upsell');
    if (doneBtn && doneBtn.dataset.label) doneBtn.textContent = doneBtn.dataset.label;
  }
  window.siteBundle.showUpsell = showUpsell;
  dlg.addEventListener('close', function () { setTimeout(resetUpsell, 0); });

  function loadPage(url, append) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=site-bundle-products')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var page = doc.querySelector('.site-bundle-page');
        if (!page) return;
        var grid = body.querySelector('.site-bundle-grid');
        if (!append || !grid) {
          body.innerHTML = '<div class="site-bundle__featured-slot"></div><div class="site-bundle-grid"></div>';
          grid = body.querySelector('.site-bundle-grid');
          placeFeatured();
        }
        Array.prototype.slice.call(page.children).forEach(function (c) { grid.appendChild(c); }); // copy first: page.children is live and shrinks as cards move
        hideCurrentInGrid();
        var more = body.querySelector('.site-bundle__more');
        if (more) more.remove();
        if (page.dataset.next) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'site-bundle__more';
          btn.textContent = 'Load more';
          btn.addEventListener('click', function () {
            btn.disabled = true;
            loadPage(page.dataset.next, true);
          });
          body.appendChild(btn);
        }
      });
  }

  // The product being viewed: featured first (alone, highlighted) unless it's already in the cart.
  // Always featured first, even when already in the cart (the shopper may want another color of it).
  var current = { id: null, template: null, qty: 0 };

  function placeFeatured() {
    var slot = body.querySelector('.site-bundle__featured-slot');
    if (!slot) return;
    slot.innerHTML = '';
    if (!current.template) return;
    slot.appendChild(current.template.content.cloneNode(true));
    if (current.qty > 0) {
      var badge = slot.querySelector('.site-bundle-card__added');
      badge.hidden = false;
      badge.querySelector('[data-count]').textContent = current.qty;
      slot.querySelector('.site-bundle-card').classList.add('is-added');
      var btn = slot.querySelector('.site-bundle-card__add');
      if (current.template.dataset.againLabel) btn.textContent = current.template.dataset.againLabel;
    }
  }

  function hideCurrentInGrid() {
    body.querySelectorAll('.site-bundle-grid .site-bundle-card').forEach(function (card) {
      card.hidden = current.id !== null && card.dataset.productId === current.id;
    });
  }

  function openBundle(opener) {
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    addedSomething = false;
    var bar = opener && opener.closest('.site-bxgy');
    current.template = bar ? bar.querySelector('template[data-site-bundle-current]') : null;
    current.id = current.template ? current.template.dataset.productId : null;
    current.qty = 0;
    placeFeatured();
    hideCurrentInGrid();
    dlg.showModal();
    refreshFromCart().then(function (cart) {
      if (!current.id || !cart) return;
      current.qty = cart.items.reduce(function (n, i) { return String(i.product_id) === current.id ? n + i.quantity : n; }, 0);
      if (current.qty > 0) placeFeatured();
    });
    if (!loaded) {
      loaded = true;
      loadPage(dlg.dataset.url, false).catch(function () { loaded = false; });
    }
  }

  function closeBundle(openCart) {
    dlg.close();
    var drawer = document.querySelector('cart-drawer');
    if (openCart || addedSomething) {
      if (drawer) drawer.open();
      else window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
    }
  }

  document.addEventListener('click', function (e) {
    var bundleOpener = e.target.closest('[data-site-bundle-open]');
    if (bundleOpener && !bundleOpener.hasAttribute('data-pick-slot') && window.sitePick) window.sitePick = null;
    if (bundleOpener) {
      dlg.classList.toggle('is-picking', bundleOpener.hasAttribute('data-pick-slot'));
      // each picking session starts with clean "added" badges
      dlg.querySelectorAll('.site-bundle-card.is-added').forEach(function (c) {
        c.classList.remove('is-added');
        var b = c.querySelector('.site-bundle-card__added');
        if (b) b.hidden = true;
      });
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active')) drawer.close();
      openBundle(bundleOpener);
      return;
    }
    if (!dlg.open) return;
    if (e.target.closest('[data-site-bundle-done]')) {
      if (upsellState && upsellState.mode === 'pick' && upsellState.offer) {
        var offer = upsellState.offer;
        doneBtn.setAttribute('aria-busy', 'true');
        Promise.resolve(offer.addBundle()).then(function () { dlg.close(); }).finally(function () { doneBtn.removeAttribute('aria-busy'); });
      } else {
        closeBundle(true);
      }
    }
    else if (e.target.closest('[data-site-bundle-close]') || e.target === dlg) closeBundle(false);
  });
  dlg.addEventListener('close', function () {
    if (dlg.classList.contains('is-picking')) {
      dlg.classList.remove('is-picking');
      setTimeout(function () { window.sitePick = null; }, 0);
    }
  });
  dlg.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeBundle(false);
  });
})();

/* Site — "I want only this one": add just the product being viewed, with the options chosen on the page. */
document.addEventListener('click', function (e) {
  var link = e.target.closest('[data-site-add-single]');
  if (!link) return;
  e.preventDefault();
  var main = document.querySelector('product-info product-form [name="add"], product-form [name="add"]');
  if (main && !main.disabled) main.click();
  else if (main) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

/* Site — "Complete your look" (cart + product page): clicking the image or name opens the quick-add popup instead of leaving the page. */
document.addEventListener('click', function (e) {
  var hit = e.target.closest('.site-upsell__media, .site-upsell__name, .site-cross-sell__media, .site-cross-sell__name');
  if (!hit) return;
  var card = hit.closest('.site-upsell__card, .site-cross-sell__item');
  var add = card && card.querySelector('[data-site-quick-add]');
  if (!add) return;
  e.preventDefault();
  add.click();
});

/* Site — "Bundle & Save" offer on the product page. */
if (!customElements.get('site-bundle-offer')) {
  customElements.define(
    'site-bundle-offer',
    class SiteBundleOffer extends HTMLElement {
      connectedCallback() {
        this.buy = Number(this.dataset.buy);
        this.get = Number(this.dataset.get);
        this.size = this.buy + this.get;
        this.picks = new Array(this.size - 1).fill(null);
        this.variants = JSON.parse(this.querySelector('[data-site-variants]').textContent);
        this.form = document.getElementById(this.dataset.form);
        this.chooseLabel(); // read the button label before the slots get re-rendered

        this.addEventListener('change', (e) => {
          if (e.target.name && e.target.name.indexOf('site-bo-') === 0) this.setMode(e.target.value);
        });
        this.querySelector('[data-mode="bundle"]').addEventListener('click', (e) => {
          if (!e.target.closest('input, [data-pick-slot], .site-bo__remove')) this.setMode('bundle');
        });
        this.addEventListener('click', (e) => {
          const slotBtn = e.target.closest('[data-pick-slot]');
          if (slotBtn) this.startPick(Number(slotBtn.dataset.pickSlot));
          const rm = e.target.closest('.site-bo__remove');
          if (rm && rm.hasAttribute('data-cart-remove')) {
            e.preventDefault();
            const s = Number(rm.dataset.cartRemove);
            const id = s === 0 ? this.current().id : this.picks[s - 1] && this.picks[s - 1].id;
            if (id) this.removeFromCart(id, rm);
          } else if (rm) { e.preventDefault(); this.picks[Number(rm.dataset.slot) - 1] = null; this.renderSlot(Number(rm.dataset.slot)); this.update(); this.savePending(); }
        }, true);

        // the page's variant pickers change the first slot + prices
        const info = this.closest('product-info') || document;
        info.addEventListener('change', (e) => {
          if (e.target.name && e.target.name.indexOf('site-bo-') === 0) return;
          setTimeout(() => this.syncCart(), 80);
        });

        // "Add to cart" adds the whole bundle when the bundle option is selected
        this.onSubmit = (e) => {
          if (e.target !== this.form || this.mode !== 'bundle') return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addBundle();
        };
        document.addEventListener('submit', this.onSubmit, true);

        this.setMode(this.querySelector('input[value="bundle"]').checked ? 'bundle' : 'single');

        // the widget is NOT synced with the cart: every visit starts a fresh bundle (this strap + empty slots)
        this.storeKey = 'siteBundle:' + (this.closest('product-info') ? this.closest('product-info').dataset.url : location.pathname);
        try { localStorage.removeItem(this.storeKey); } catch (e) {}
        this.syncCart();
      }

      // "×" on a strap already in the cart: take one unit of it out of the cart
      removeFromCart(variantId, btn) {
        if (btn) btn.disabled = true;
        const drawer = document.querySelector('cart-drawer');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const line = cart.items.find((i) => String(i.variant_id) === String(variantId));
            if (!line) return null;
            const body = { id: line.key, quantity: line.quantity - 1 };
            if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            }).then((r) => r.json());
          })
          .then((res) => {
            if (res && res.sections && drawer) {
              // refresh the drawer without opening it
              ['cart-drawer', 'cart-icon-bubble'].forEach((id) => {
                const html = res.sections[id];
                if (!html) return;
                const doc = new DOMParser().parseFromString(html, 'text/html');
                if (id === 'cart-drawer') {
                  const src = doc.querySelector('.drawer__inner'), dst = document.querySelector('cart-drawer .drawer__inner');
                  if (src && dst) dst.innerHTML = src.innerHTML;
                  drawer.classList.toggle('is-empty', res.item_count === 0);
                } else {
                  const src = doc.querySelector('.shopify-section'), dst = document.getElementById('cart-icon-bubble');
                  if (src && dst) dst.innerHTML = src.innerHTML;
                }
              });
            }
            if (window.siteRefreshBxgy) window.siteRefreshBxgy();
            return this.syncCart();
          })
          .catch(() => { if (btn) btn.disabled = false; });
      }

      savePending() {} // picks are not kept between visits

      // re-render the slots from the shopper's picks only (no cart lookup)
      syncCart() {
        this.currentInCart = false;
        this.picks = this.picks.map((p) => (p && !p.inCart ? p : null));
        for (let i = 1; i < this.size; i++) this.renderSlot(i);
        const rm0 = this.querySelector('[data-slot="0"] [data-cart-remove]');
        if (rm0) rm0.hidden = true;
        this.update();
        return Promise.resolve();
      }

      disconnectedCallback() { document.removeEventListener('submit', this.onSubmit, true); }

      money(cents) {
        const fmt = this.dataset.moneyFormat || '${{amount}}';
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
          const v = cents / 100;
          if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
          if (k.indexOf('comma') > -1) return v.toFixed(2).replace('.', ',');
          return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        });
      }

      current() {
        const id = this.form && this.form.querySelector('[name="id"]') && this.form.querySelector('[name="id"]').value;
        return this.variants.find((v) => String(v.id) === String(id)) || this.variants[0];
      }

      setMode(mode) {
        this.mode = mode;
        this.querySelectorAll('.site-bo__opt').forEach((o) => o.classList.toggle('is-active', o.dataset.mode === mode));
        const r = this.querySelector('input[value="' + mode + '"]');
        if (r) r.checked = true;
        this.update();
      }

      startPick(slot) {
        window.sitePick = (res) => {
          const v = res.variant, p = res.product;
          this.picks[slot - 1] = { id: v.id, price: v.price_cents, compare: v.compare_cents, title: p.title, variant: v.title, image: v.image || p.image };
          this.savePending();
          this.setMode('bundle');
          this.renderSlot(slot);
          this.update();
          const dlg = document.getElementById('SiteBundle');
          const next = this.picks.findIndex((x) => !x);
          if (next > -1 && dlg && dlg.open && dlg.dataset.closeEachPick === 'true') {
            // test mode: close the popup after every pick, the shopper continues from the widget
            this.syncPopup(dlg);
            dlg.close();
            const w = this.querySelector('[data-mode="bundle"]');
            // after the dialog has restored the page scroll, bring the widget back into view
            if (w) setTimeout(() => {
              const top = w.getBoundingClientRect().top + window.scrollY - (window.innerHeight - w.offsetHeight) / 2;
              window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
            }, 450);
          } else if (next > -1 && dlg && dlg.open) {
            // keep the popup open until the bundle is complete
            this.startPick(next + 1);
            this.syncPopup(dlg);
          } else if (dlg && dlg.open) {
            this.syncPopup(dlg);
            const shown = window.siteBundle && window.siteBundle.showUpsell && window.siteBundle.showUpsell('pick', this);
            if (!shown) {
              // bundle complete: add it and go straight to the cart (no stop on the product page)
              setTimeout(() => {
                Promise.resolve(this.addBundle()).then(() => { if (dlg.open) dlg.close(); });
              }, 500);
            }
          }
        };
        const dlg = document.getElementById('SiteBundle');
        if (dlg) setTimeout(() => this.syncPopup(dlg), 0);
      }

      // while filling slots, the popup header shows the bundle progress (not the cart's)
      syncPopup(dlg) {
        const filled = 1 + this.picks.filter(Boolean).length;
        const msg = dlg.querySelector('.site-bundle__progress .site-bxgy__msg');
        const fill = dlg.querySelector('.site-bundle__progress .site-bxgy__fill');
        const bar = dlg.querySelector('.site-bundle__progress .site-bxgy');
        if (msg) msg.textContent = this.querySelector('[data-msg]').textContent;
        if (fill) fill.style.width = Math.round((filled * 100) / this.size) + '%';
        if (bar) {
          bar.classList.toggle('is-unlocked', filled >= this.size);
          bar.querySelectorAll('.site-bxgy__step').forEach((s, i) => s.classList.toggle('is-done', i < filled));
        }
      }

      renderSlot(slot) {
        const li = this.querySelector('[data-slot="' + slot + '"]');
        const pick = this.picks[slot - 1];
        const isFree = slot === this.size - 1 && this.get > 0;
        if (!pick) {
          li.classList.remove('is-filled');
          li.innerHTML = '<button type="button" class="site-bo__pick" data-site-bundle-open data-pick-slot="' + slot + '">' +
            '<span class="site-bo__plus" aria-hidden="true">+</span><span class="site-bo__choose">' + this.chooseLabel() + '</span>' +
            (isFree ? '<span class="site-bo__free">FREE</span>' : '') + '</button>';
          return;
        }
        li.classList.add('is-filled');
        const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const head = '<span class="site-bo__thumb"><img src="' + esc((pick.image || '').replace(/width=\d+/, 'width=160')) + '" alt="" width="56" height="56"></span>' +
          '<span class="site-bo__info"><span class="site-bo__name">' + esc(pick.title) + '</span><span class="site-bo__variant">' + esc(pick.variant) + '</span></span>';
        const price = '<span class="site-bo__amount">' + this.money(pick.price).replace(/\s*[A-Z]{3}$/, '') + '</span>';
        if (pick.inCart) {
          li.innerHTML = head + '<span class="site-bo__side">' + price + '<span class="site-bo__actions">' +
            '<span class="site-bo__tag is-in-cart">✓ In cart</span>' +
            '<button type="button" class="site-bo__remove" data-cart-remove="' + slot + '" aria-label="Remove from cart">×</button></span></span>';
          return;
        }
        li.innerHTML = head + '<span class="site-bo__side">' + price + '<span class="site-bo__actions">' +
          '<button type="button" class="site-bo__change" data-site-bundle-open data-pick-slot="' + slot + '">Change</button>' +
          '<button type="button" class="site-bo__remove" data-slot="' + slot + '" aria-label="Remove">×</button></span></span>';
      }

      chooseLabel() {
        if (!this._choose) {
          const c = this.querySelector('.site-bo__choose');
          this._choose = c ? c.textContent : 'Choose';
        }
        return this._choose;
      }

      update() {
        const cur = this.current();
        // slot 0 = this strap with the variant selected on the page
        const img = this.querySelector('[data-current-img]');
        if (img && cur.image) img.src = cur.image;
        const vt = this.querySelector('[data-current-variant]');
        if (vt) vt.textContent = cur.title;
        const cp = this.querySelector('[data-current-price]');
        if (cp) cp.textContent = this.money(cur.price).replace(/\s*[A-Z]{3}$/, '');

        const sp = this.querySelector('[data-single-price]'), sc = this.querySelector('[data-single-compare]');
        sp.textContent = this.money(cur.price);
        sc.hidden = !(cur.compare > cur.price);
        if (cur.compare > cur.price) sc.textContent = this.money(cur.compare);

        // bundle total = this strap + the straps picked so far; once the bundle is complete the cheapest one(s) are free
        const items = [cur].concat(this.picks.filter(Boolean));
        const prices = items.map((i) => i.price).sort((a, b) => a - b);
        const freeTotal = items.length >= this.size ? prices.slice(0, this.get).reduce((a, b) => a + b, 0) : 0;
        const total = prices.reduce((a, b) => a + b, 0) - freeTotal;
        const compare = items.reduce((a, i) => a + Math.max(i.compare || 0, i.price), 0);
        this.querySelector('[data-bundle-price]').textContent = this.money(total);
        // until every case is picked, the price is only "so far": show what is left instead of a strikethrough
        const complete = items.length >= this.size;
        const hint = this.querySelector('[data-bundle-hint]');
        if (hint) {
          hint.hidden = complete;
          hint.textContent = '+ ' + (this.size - items.length) + ' more, ' + this.get + ' free';
        }
        const cmp = this.querySelector('[data-bundle-compare]');
        cmp.hidden = !complete || !(compare > total);
        cmp.textContent = this.money(compare);

        // once the bundle is complete, show which strap is free: its price struck through + FREE
        const short = (c) => this.money(c).replace(/\s*[A-Z]{3}$/, '');
        const bySlot = [{ slot: 0, price: cur.price }].concat(this.picks.map((p, i) => (p ? { slot: i + 1, price: p.price } : null)).filter(Boolean));
        const freeSlots = items.length >= this.size
          ? bySlot.slice().sort((a, b) => a.price - b.price || b.slot - a.slot).slice(0, this.get).map((x) => x.slot)
          : [];
        bySlot.forEach((x) => {
          const el = x.slot === 0 ? this.querySelector('[data-current-price]') : this.querySelector('[data-slot="' + x.slot + '"] .site-bo__amount');
          if (!el) return;
          const isFree = freeSlots.indexOf(x.slot) > -1;
          el.classList.toggle('is-free', isFree);
          el.innerHTML = isFree ? '<s>' + short(x.price) + '</s> <span class="site-bo__free-price">FREE</span>' : short(x.price);
        });

        // progress inside the widget
        const filled = 1 + this.picks.filter(Boolean).length;
        const remaining = this.size - filled;
        let msg;
        if (remaining <= 0) msg = this.dataset.msgDone;
        else if (remaining === 1 && this.get > 0) msg = this.dataset.msgNext;
        else msg = (this.dataset.msgStart || '').split('[remaining]').join(remaining);
        this.querySelector('[data-msg]').textContent = msg;
        this.querySelector('[data-fill]').style.width = Math.round((filled * 100) / this.size) + '%';
        this.classList.toggle('is-complete', remaining <= 0);
      }

      addBundle() {
        const firstEmpty = this.picks.findIndex((p) => !p);
        if (firstEmpty > -1) {
          // bundle not complete: open the picker for the next empty slot
          const btn = this.querySelector('[data-pick-slot="' + (firstEmpty + 1) + '"]');
          if (btn) btn.click();
          return;
        }
        const submit = this.form.querySelector('[name="add"]');
        if (submit) submit.setAttribute('aria-busy', 'true');
        const drawer = document.querySelector('cart-drawer');
        const toAdd = (this.currentInCart ? [] : [this.current()]).concat(this.picks.filter((p) => p && !p.inCart));
        if (!toAdd.length) {
          // everything is already in the cart: just show it
          if (drawer) drawer.open(); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          if (submit) submit.removeAttribute('aria-busy');
          return Promise.resolve();
        }
        const items = toAdd.map((p) => ({ id: Number(p.id), quantity: 1 }));
        const body = { items: items };
        if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
        return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status && res.description) { alert(res.description); return; }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'site-bundle-offer', cartData: res });
            // the picks stay until the page is refreshed or left
            if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
            else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          })
          .finally(() => { if (submit) submit.removeAttribute('aria-busy'); });
      }
    }
  );
}

/* Site — bundle popup cards: choose size & color inline, add without a second popup. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function data(card) {
    if (!card._site) card._site = JSON.parse(card.querySelector('[data-variants]').textContent);
    return card._site;
  }
  function selected(card) {
    var sel = [];
    card.querySelectorAll('[data-opt]').forEach(function (el) {
      var i = Number(el.dataset.opt);
      if (el.tagName === 'SELECT') sel[i] = el.value;
      else if (el.classList.contains('is-active')) sel[i] = el.dataset.val;
    });
    return sel;
  }
  function variantFor(card, sel) {
    var d = data(card);
    return d.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === undefined || o === sel[i]; }); });
  }
  function refresh(card) {
    var v = variantFor(card, selected(card));
    var price = card.querySelector('[data-price]');
    var btn = card.querySelector('[data-site-inline-add]');
    if (v) {
      price.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      var img = card.querySelector('.site-bundle-card__media img');
      if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
    }
    btn.disabled = !v || !v.available;
    btn.textContent = !v ? 'Unavailable' : v.available ? '+ Add' : 'Sold out';
    return v;
  }
  // pick an available combination that keeps the option the shopper just changed
  function settle(card, changedIndex) {
    var sel = selected(card);
    var v = variantFor(card, sel);
    if (v && v.available) return;
    var alt = data(card).variants.find(function (x) { return x.available && x.options[changedIndex] === sel[changedIndex]; });
    if (!alt) return;
    card.querySelectorAll('[data-opt]').forEach(function (el) {
      var i = Number(el.dataset.opt);
      if (i === changedIndex) return;
      if (el.tagName === 'SELECT') el.value = alt.options[i];
      else el.classList.toggle('is-active', el.dataset.val === alt.options[i]);
    });
  }

  // pre-select the watch size the shopper already has (page or cart), then sync each new card
  function initCards(scope) {
    var hint = (window.siteSizeFromPage && window.siteSizeFromPage()) || window.siteCartSizeHint;
    scope.querySelectorAll('.site-bundle-card:not([data-ready])').forEach(function (card) {
      if (!card.querySelector('[data-variants]')) return;
      card.setAttribute('data-ready', '');
      if (hint && window.sitePickByHint) {
        card.querySelectorAll('select[data-opt]').forEach(function (s) {
          var m = window.sitePickByHint([].map.call(s.options, function (o) { return o.value; }), hint);
          if (m) s.value = m;
        });
      }
      var firstSelect = card.querySelector('select[data-opt]');
      settle(card, firstSelect ? Number(firstSelect.dataset.opt) : 0);
      refresh(card);
    });
  }
  new MutationObserver(function () {
    var pop = document.getElementById('SiteBundle');
    if (pop) initCards(pop);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('.site-bundle-card__select');
    if (!s) return;
    var card = s.closest('.site-bundle-card');
    settle(card, Number(s.dataset.opt));
    refresh(card);
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.site-bundle-card__color');
    if (sw) {
      var card = sw.closest('.site-bundle-card');
      card.querySelectorAll('.site-bundle-card__color[data-opt="' + sw.dataset.opt + '"]').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      settle(card, Number(sw.dataset.opt));
      refresh(card);
      return;
    }
    var btn = e.target.closest('[data-site-inline-add]');
    if (!btn) return;
    var c = btn.closest('.site-bundle-card');
    var v = refresh(c);
    if (!v || !v.available) return;
    var d = data(c);

    if (typeof window.sitePick === 'function') {
      // filling a Bundle & Save slot (the popup stays open until the bundle is complete)
      var pick = window.sitePick;
      window.sitePick = null;
      var badge = c.querySelector('.site-bundle-card__added');
      if (badge) {
        var n = badge.querySelector('[data-count]');
        n.textContent = badge.hidden ? 1 : Number(n.textContent) + 1;
        badge.hidden = false;
      }
      c.classList.add('is-added');
      btn.textContent = '✓ Added';
      setTimeout(function () { refresh(c); }, 1200);
      pick({ variant: v, product: { title: d.title, image: d.image } });
      return;
    }

    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    fetch(((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { btn.textContent = res.description; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'site-bundle-card', cartData: res });
        if (window.siteBundle) window.siteBundle.afterAdd(res, btn);
        btn.textContent = '✓ Added';
        setTimeout(function () { refresh(c); }, 1400);
      })
      .finally(function () { btn.disabled = false; });
  });
})();

/* Site — welcome popup (newsletter + first-order code). */
(function () {
  'use strict';
  var dlg = document.getElementById('SiteWelcome');
  if (!dlg) return;
  var KEY = 'siteWelcome';
  var code = dlg.dataset.code;
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  function busy() {
    var drawer = document.querySelector('cart-drawer');
    return !!document.querySelector('dialog[open]') || (drawer && drawer.classList.contains('active'));
  }
  function open(force) {
    if (dlg.open) return;
    if (!force && busy()) { setTimeout(function () { open(false); }, 4000); return; }
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    dlg.showModal();
  }
  function close() {
    if (!state.subscribed) { state.dismissedAt = Date.now(); save(); }
    dlg.close();
  }

  var params = new URLSearchParams(location.search);
  var posted = params.get('customer_posted') === 'true' && location.hash === '#SiteWelcomeForm';
  var success = !!dlg.querySelector('[data-site-welcome-success]');

  if (posted && success) {
    // signed up: remember it, pre-apply the code to the cart session, show the code
    state.subscribed = true; save();
    if (code) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    history.replaceState(null, '', location.pathname);
    open(true);
  } else if (location.hash === '#SiteWelcomeForm' && dlg.querySelector('.site-welcome__error')) {
    open(true); // invalid email: show the error
  } else if (dlg.hasAttribute('data-preview')) {
    setTimeout(function () { open(true); }, 400); // theme editor preview
  } else if (!state.subscribed) {
    var days = Number(dlg.dataset.days || 7);
    var recentlyClosed = state.dismissedAt && Date.now() - state.dismissedAt < days * 864e5;
    if (!recentlyClosed) {
      // product pages (ad landing pages): no timer unless enabled — only the exit intent below
      var timerOk = dlg.dataset.page !== 'product' || dlg.dataset.pdp === 'true';
      // not on the first page of a visit (69 closes for 5 sign-ups when it greeted ad traffic on landing):
      // the timer only runs from the 2nd page view of the session; exit intent below still applies
      var views = 0;
      try { views = Number(sessionStorage.getItem('icPageViews') || 0) + 1; sessionStorage.setItem('icPageViews', String(views)); } catch (e) { views = 2; }
      if (views < 2) timerOk = false;
      if (timerOk) setTimeout(function () { open(false); }, Number(dlg.dataset.delay || 20) * 1000);
      if (dlg.dataset.exit === 'true' && window.matchMedia('(min-width: 750px)').matches) {
        document.addEventListener('mouseout', function onOut(e) {
          if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(false); }
        });
      }
    }
  }

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-site-welcome-close]')) {
      if (e.target.closest('a[data-site-welcome-close]')) { dlg.close(); return; } // success link: let it navigate
      e.preventDefault();
      close();
      return;
    }
    var copy = e.target.closest('[data-site-welcome-copy]');
    if (copy && code) {
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(function () {}).finally(function () {
        var small = copy.querySelector('small');
        if (small) small.textContent = copy.dataset.copied || 'Copied';
      });
    }
  });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
})();

/* ================= Cart drawer — "Complete your look" cards (one dropdown per option + "+ Add") ================= */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function variantsOf(card) {
    if (!card._nbagVariants) {
      var el = card.querySelector('script[data-nbag-variants]');
      try { card._nbagVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { card._nbagVariants = []; }
    }
    return card._nbagVariants;
  }

  function sync(card) {
    var selects = card.querySelectorAll('select[data-nbag-opt]');
    if (!selects.length) return;
    var chosen = [].map.call(selects, function (s) { return s.value; });
    var v = variantsOf(card).filter(function (x) {
      return chosen.every(function (val, i) { return x.options[i] === val; });
    })[0];
    var btn = card.querySelector('[data-nbag-add]');
    var price = card.querySelector('[data-nbag-price]');
    if (!btn) return;
    if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
    if (v && v.available) {
      btn.setAttribute('data-variant-id', v.id);
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-label');
    } else {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    }
    if (v && price) price.textContent = v.price;
    // show the photo of the chosen variant
    var img = card.querySelector('.nbag-up__media img');
    if (v && v.image && img && img.getAttribute('src') !== v.image) {
      // keep the current photo until the new one is loaded (no blank flash)
      var next = new Image();
      next.onload = function () {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.loading = 'eager';
        img.src = v.image;
      };
      next.src = v.image;
    }
  }

  // pre-select the watch size of the strap already in the cart
  function presetSizes(scope) {
    if (!window.sitePickByHint) return;
    (scope || document).querySelectorAll('select[data-nbag-opt][data-size-hint]:not([data-preset])').forEach(function (s) {
      s.setAttribute('data-preset', '');
      var m = window.sitePickByHint([].map.call(s.options, function (o) { return o.value; }), s.getAttribute('data-size-hint'));
      if (m) {
        s.value = m;
        var card = s.closest('[data-nbag-card]');
        if (card) sync(card);
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('select[data-nbag-opt]')) {
      var card = e.target.closest('[data-nbag-card]');
      if (card) sync(card);
    }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nbag-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (drawer && res.sections) drawer.renderContents(res);
        if (window.siteRefreshBxgy) window.siteRefreshBxgy();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = (err && err.message) || 'Error';
      });
  });

  var target = document.getElementById('CartDrawer');
  presetSizes(target || document);
  if (target && window.MutationObserver) {
    new MutationObserver(function () { presetSizes(target); }).observe(target, { childList: true, subtree: true });
  }
})();

/* Site — bundle popup: "Your device" filter. Shows only cases that fit the chosen phone and pre-selects that model on each card. */
(function () {
  'use strict';
  var dlg = document.getElementById('SiteBundle');
  if (!dlg) return;
  var body = dlg.querySelector('[data-site-bundle-body]');
  if (!body) return;
  var KEY = 'siteBundleDevice';
  var MODEL_RX = /^(model|size|device|phone)/i;

  // filter bar under the popup titles
  var bar = document.createElement('div');
  bar.className = 'site-bundle-filter';
  bar.innerHTML = '<label class="site-bundle-filter__label" for="SiteBundleDevice">Your device</label>' +
    '<select id="SiteBundleDevice" class="site-bundle-filter__select" data-site-bundle-device><option value="">All devices</option></select>' +
    '<p class="site-bundle-filter__empty" hidden>No case available for this device yet.</p>';
  var head = dlg.querySelector('.site-bundle__head');
  (head || dlg).insertBefore(bar, head ? head.querySelector('.site-bundle__progress') : body);
  var select = bar.querySelector('select');
  var empty = bar.querySelector('.site-bundle-filter__empty');

  var DEVICE_RX = /^(iPhone|Samsung|Galaxy)/i;
  function modelSelect(card) {
    var found = null;
    card.querySelectorAll('select[data-opt]').forEach(function (s) {
      if (!found && MODEL_RX.test(s.getAttribute('aria-label') || '')) found = s;
    });
    return found;
  }
  // every phone model a card fits, read from its variant data (covers products with a single model and no selector)
  function cardModels(card) {
    if (card._siteModels) return card._siteModels;
    var out = [];
    try {
      var d = JSON.parse(card.querySelector('[data-variants]').textContent);
      (d.variants || []).forEach(function (v) {
        (v.options || []).forEach(function (o) { if (DEVICE_RX.test(o) && out.indexOf(o) < 0) out.push(o); });
      });
    } catch (e) {}
    if (!out.length) {
      var s = modelSelect(card);
      if (s) Array.prototype.forEach.call(s.options, function (o) { out.push(o.value); });
    }
    card._siteModels = out;
    return out;
  }
  function cards() { return body.querySelectorAll('.site-bundle-card'); }
  function sortKey(m) {
    var n = (m.match(/\d+/) || ['0'])[0];
    var rank = /pro max/i.test(m) ? 0 : /pro/i.test(m) ? 1 : /plus|air/i.test(m) ? 2 : 3;
    return (/duo/i.test(m) ? '0' : '1') + String(100 - Number(n)).padStart(3, '0') + rank + m;
  }
  function rebuildOptions() {
    var models = {};
    cards().forEach(function (c) {
      cardModels(c).forEach(function (m) { models[m] = true; });
    });
    var current = select.value;
    var list = Object.keys(models).sort(function (a, b) { return sortKey(a) < sortKey(b) ? -1 : 1; });
    var have = Array.prototype.map.call(select.options, function (o) { return o.value; }).slice(1);
    if (list.join('|') === have.join('|')) return;
    select.innerHTML = '<option value="">All devices</option>' + list.map(function (m) {
      return '<option value="' + m.replace(/"/g, '&quot;') + '">' + m + '</option>';
    }).join('');
    if (current && models[current]) select.value = current;
  }
  function pageModel() {
    var vals = [];
    document.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked, .product-form__input select').forEach(function (el) { vals.push(el.value); });
    for (var i = 0; i < vals.length; i++) if (/^(iPhone|Samsung|Galaxy)/i.test(vals[i])) return vals[i];
    return null;
  }
  function apply() {
    var device = select.value;
    var shown = 0;
    cards().forEach(function (c) {
      var s = modelSelect(c);
      var fits = !device || cardModels(c).indexOf(device) > -1;
      c.classList.toggle('is-device-hidden', !fits);
      if (fits && !c.hidden) shown++;
      if (fits && device && s && s.value !== device && Array.prototype.some.call(s.options, function (o) { return o.value === device; })) {
        s.value = device;
        s.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    empty.hidden = !device || shown > 0 || !!body.querySelector('.site-bundle__more');
  }
  function autoLoadAll() {
    var more = body.querySelector('.site-bundle__more:not([disabled])');
    if (more && dlg.open) more.click();
  }
  var pendingWant = null; // device to pre-select once its option exists (page model or last choice)
  var userPicked = false;
  var timer = null;
  function run() {
    rebuildOptions();
    if (pendingWant && !userPicked && Array.prototype.some.call(select.options, function (o) { return o.value === pendingWant; })) {
      select.value = pendingWant;
      pendingWant = null;
    }
    apply();
    autoLoadAll();
  }
  // debounced: the last change always triggers a pass (new page loaded, card refreshed…)
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 60);
  }).observe(body, { childList: true, subtree: true });

  select.addEventListener('change', function () {
    userPicked = true;
    try { sessionStorage.setItem(KEY, select.value); } catch (e) {}
    apply();
  });

  // default device: the model picked on this product page, else the last one chosen in the popup
  var obs = new MutationObserver(function () {
    if (!dlg.open) return;
    var want = pageModel();
    if (!want) { try { want = sessionStorage.getItem(KEY); } catch (e) {} }
    userPicked = false;
    pendingWant = want || null;
    run();
  });
  obs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
})();

